import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { UiModule } from '@app/ui';
import { UIState } from '@app/ui/states/ui.state';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ASSET_GROUP_GAP } from '../../services/assets-ui-service';
import { AssetKey, AssetsState } from '../../states/assets.state';
import { AssetDisplayComponent } from '../asset-display/asset-display.component';

@Component({
  selector: 'rk-splashscreen-assets-section',
  templateUrl: './splashscreen-assets-section.component.html',
  styleUrl: './splashscreen-assets-section.component.scss',
  standalone: true,
  imports: [AsyncPipe, UiModule, AssetDisplayComponent, FontAwesomeModule, TranslatePipe],
})
export class SplashscreenAssetsSectionComponent {
  @Select(UIState.isCreationProcess) isCreationProcess$: Observable<boolean>;
  @Select(AppConfigurationState.availableOnAndroidTV)
  availableOnAndroidTV$: Observable<boolean>;
  @Select(AssetsState.smartphoneSplashscreenURL) smartphoneURL$: Observable<string>;
  @Select(AssetsState.smartphoneLargeSplashscreenURL)
  smartphoneLargeURL$: Observable<string>;
  @Select(AssetsState.tvSplashscreenURL) tvSplashscreenURL$: Observable<string>;
  @Select(AssetsState.topShelfTvURL) topShelfTvURL$: Observable<string>;
  @Select(AppConfigurationState.availableOnAppleTV)
  availableOnAppleTV$: Observable<boolean>;
  @Input() assetWidth = 200;
  @Output() readonly crop = new EventEmitter<AssetKey>();
  @Output() readonly replace = new EventEmitter<AssetKey>();
  assetGroupGap = ASSET_GROUP_GAP;

  onCrop(assetKey: AssetKey): void {
    this.crop.emit(assetKey);
  }

  onReplace(assetKey: AssetKey): void {
    this.replace.emit(assetKey);
  }
}
